import { useEffect, useState } from "react";
import { SebiDisclosureKind, isFnoEnabled, isSebiDisclosureDueNow, sebiDisclosureKindFor } from "../../utils/sebiDisclosureConfig";
import { refreshRemoteConfig } from "../../utils/remoteConfig";

// Picks today's SEBI message for the login disclosure card; null means nothing is due.
export const useSebiDisclosure = (
  showDisclosure: boolean,
  setShowDisclosure: (show: boolean) => void,
  showNext: boolean,
  acknowledge: () => void
) => {
  const [disclosureKind, setDisclosureKind] = useState<SebiDisclosureKind | null | undefined>(undefined);

  // Fresh config first: a stale or not-yet-fetched value falls back to the 1 Nov start date.
  const openDisclosure = async (exchanges?: string[]) => {
    await refreshRemoteConfig();
    const kind = sebiDisclosureKindFor(isFnoEnabled(exchanges));
    setDisclosureKind(kind && isSebiDisclosureDueNow() ? kind : null);
    setShowDisclosure(true);
  };

  // "I understand" is what redirects, so with nothing due (and no KRA page) continue straight on.
  useEffect(() => {
    if (!showDisclosure || showNext || disclosureKind !== null) return;
    const timer = setTimeout(acknowledge, 0);
    return () => clearTimeout(timer);
  },[showDisclosure, showNext, disclosureKind]);

  return { disclosureKind, openDisclosure, skipDisclosureCard: disclosureKind === null && !showNext };
};
